import React, { Component } from 'react';
import './App.css';

import { Route, Switch } from "react-router-dom";
// import { Router, Route, Switch } from 'react-router-dom';

//custom modules
import NavBarA from './components/TopNavBar';
import Login from './components/Login';
import FeedbackRating from './components/Feedback';
import Roles from './components/Roles';
import Tasks from './components/Tasks';

//FontAwsome import
import { library } from '@fortawesome/fontawesome-svg-core';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIgloo } from '@fortawesome/free-solid-svg-icons';

library.add(faIgloo);
class App extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={() => <Login hub={this.props.hub}/>} />
        <Route path="/Roles/" component={() => <Roles hub={this.props.hub}/>} />
        <Route path="/TopNavBar/" component={NavBarA} />
        <Route path="/Feedback/" component={() => <FeedbackRating hub={this.props.hub}/>} />
        <Route path="/Tasks/" component={() => <Tasks hub={this.props.hub}/>} />
      </Switch>
    );
  }
}

export default App;
